<template>
  <th :value="value" @click="setSortOption" v-show="isShow"  :class="headerClass">
    <span :value="value" :class="isMin">{{text}}</span>
    <v-icon :value="value" v-if="checkSorted()">{{sortIcon()}}</v-icon>
    <template v-if="!checkSorted()">
      <v-icon :value="value" class="arrow_desc">{{orderByIcon[0]}}</v-icon>
      <v-icon :value="value" class="arrow_asc">{{orderByIcon[1]}}</v-icon>
    </template>
  </th>
</template>

<script>
export default {
  name: 'header',
  props: {
    // data props
    custKnd: Object,
    index: Number,
    orderType: String,
    text: String,
    value: String,
    // function props
    isSorted: Function,
    setSortOption: Function
  },
  data () {
    return {
      orderByIcon: [
        'arrow_drop_down',
        'arrow_drop_up'
      ]
    }
  },
  methods: {
    checkSorted () {
      return this.isSorted(this.value)
    },
    getClass () { // 모바일 접속시 필요한 헤더만 표시하기 위해
      switch (this.index) {
        case 1:
          return 'responsive_th_2'
        case 2:
          return ''
        default:
          return 'responsive_th'
      }
    },
    sortIcon () {
      return this.orderType === 'asc' ? this.orderByIcon[1] : this.orderByIcon[0]
    }
  },
  computed: {
    headerClass () {
      return this.getClass()
    },
    isMin () {
      if (this.index === 1) return 'mini_fr_date'
    },
    isShow () { // 사용자 타입별 th표시 여부
      if (this.text === '에이전시') {
        return this.custKnd.a
      }

      if (this.text === '렙사') {
        return this.custKnd.l
      }

      return true
    }
  }
}
</script>

<style scoped>
th {
    position: relative;
    border-bottom: 2px solid #cee3f0;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  th:hover {
    cursor: pointer;
  }
  th span, th i {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  i {
    position: absolute;
    right: 0;
    vertical-align: middle;
    font-size: 25px;
    font-weight: 600;
    color: #aad7f0;
    padding-top: 2px;
  }
  
  .arrow_desc, .arrow_asc {
    font-size: 15px !important;
    color:#bebebe !important;
    right: 0 !important;
  }
  .arrow_desc {
    top: 9px;
  }
  .arrow_asc {
    top: 3px;
  }

  .responsive_th_2 {
    display: none;
  }
  @media screen and (max-width: 800px) {
    .responsive_th {
      display: none;
    }
    .responsive_th_2 {
      display: table-cell;
      text-align: left;
    }
    .mini_fr_date {
      margin-left: 10px;
    }
    i {
      right: -5px;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderComp.vue?39701dd0